/*
 * This is the fullscreen navigation bar's context. It is initialized in the PageWrapper.jsx component.
 * To see what functions and variables it holds, go to the PageWrapper.jsx component.
 */

import { createContext } from 'react';

const NavBarContext = createContext(null);

export default NavBarContext;
